module.exports = __webpack_public_path__ + "media/images/icons/logo_missing@2x-a873a9d715a64329e00213e3532fc67e.png";